import React from "react";
import ReactECharts from "echarts-for-react";

const PieChartDemoPortfolio = ({ stocks = [] }) => {
  console.log("stock", stocks);

if (!stocks || stocks.length === 0) {
  return <div style={{ height: 400 }}>Loading chart…</div>;
}

  // ✅ Filter valid stocks
  const validStocks = stocks.filter(
    s => s.stock_name && Number(s.quantity) > 0
  );

    console.log("validStocks", validStocks);

  // ✅ Convert to pie chart format
  const pieData = validStocks.map(s => ({
    name: s.stock_name,
    value: Number(s.quantity),
  }));

  console.log("pieData", pieData);

  const option = {
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} Qty ({d}%)",
    },
    legend: {
      orient: "vertical",
      left: "left",
    },
    series: [
      {
        name: "Quantity Distribution",
        type: "pie",
        radius: "65%",
        center: ["50%", "50%"],
        data: pieData,
        label: {
          formatter: "{b}\n{d}%",
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0,0,0,0.3)",
          },
        },
      },
    ],
  };

  return (
     <div style={{ width: "100%", height: 400 }}>
      <ReactECharts option={option} style={{ height: "100%" }} />
    </div>
  );
};

export default PieChartDemoPortfolio;
